"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setVal = exports.timeout = exports.getUniqueGroupIds = exports.getUniqueGroupTypes = exports.hasId = void 0;
exports.readCSV = readCSV;
exports.isDisabled = isDisabled;
exports.getNewRow = getNewRow;
var uuid_1 = require("uuid");
function readCSV(file, groups, opts, cb) {
    if (opts === void 0) { opts = { delimiter: ';', encoding: 'CP1252' }; }
    if (groups.length === 0) {
        return cb('groups-missing');
    }
    var regexString = "(^".concat(opts.delimiter, ")?(\"((?:[^\"]+|\"\")*)\"|[^").concat(opts.delimiter, "]*)(?:$|").concat(opts.delimiter, ")");
    if (file.size === 0 || !file.name.toLowerCase().endsWith('.csv')) {
        return cb('invalid-file');
    }
    var fr = new FileReader();
    fr.onload = function () {
        var result = fr.result;
        if (!result) {
            return cb('import-failed');
        }
        var parsed = parseFile(result)
            .split(/\r\n|\n/)
            .reduce(function (acc, row, i) {
            var res = matchAll(row, regexString);
            if (i === 0) {
                acc.header = res.reduce(function (acc, x, i) {
                    acc[i] = (acc[i] || []).concat([x]);
                    return acc;
                }, acc.header);
            }
            else {
                acc.data = res.reduce(function (acc, x, i) {
                    acc[i] = (acc[i] || []).concat([x]);
                    return acc;
                }, acc.data);
            }
            return acc;
        }, { header: {}, data: {} });
        var filtered = Object.entries(parsed.data).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            var filteredEmails = value
                .filter(function (value) { return value.length > 2; })
                .reduce(function (acc, email) {
                if (email.length > 0 && !acc.includes(email)) {
                    acc.push(email);
                }
                return acc;
            }, []);
            var groupId = (parsed.header[key] || ['-']).pop();
            if (filteredEmails.length > 0 && groupId) {
                var group = void 0;
                if (groups.length > 1) {
                    var id_1 = parseInt(groupId, 10);
                    group = groups.find(function (x) { return id_1 === x.id; });
                }
                else {
                    group = groups[0];
                }
                acc.push({
                    group: group ? group.id : -2,
                    emails: filteredEmails.join(', '),
                    uuid: (0, uuid_1.v4)(),
                    language: ''
                });
            }
            return acc;
        }, []);
        cb(null, filtered);
    };
    fr.onerror = function () { return cb('import-failed'); };
    fr.readAsArrayBuffer(file);
}
function parseFile(data) {
    if (typeof data === 'string') {
        return data;
    }
    var result = '';
    var code = new Uint8Array(data);
    for (var i = 0; i < code.byteLength; i++) {
        result += String.fromCharCode(code[i]);
    }
    return result;
}
function matchAll(value, regexString) {
    var re = new RegExp(regexString, 'g');
    var match;
    var res = [];
    do {
        match = re.exec(value);
        if (match) {
            var valid = match.filter(function (x) { return x; }).reverse();
            if (valid.length > 1) {
                var email = valid[0];
                // Ignore eof
                if (email.charAt(0) !== '\u0000') {
                    res.push(email);
                    continue;
                }
            }
            res.push('');
        }
    } while (match !== null && !(match && match[0] === '' && match[2] === ''));
    return res;
}
var hasId = function (x) { return x.id > -1; };
exports.hasId = hasId;
var getUniqueGroupTypes = function (items) {
    return items.reduce(function (types, item) {
        if ((0, exports.hasId)(item) && !types.includes(item.type)) {
            types.push(item.type);
        }
        return types;
    }, []);
};
exports.getUniqueGroupTypes = getUniqueGroupTypes;
var getUniqueGroupIds = function (items) {
    return items.reduce(function (ids, item) {
        if ((0, exports.hasId)(item) && !ids.includes(item.id)) {
            ids.push(item.id);
        }
        return ids;
    }, []);
};
exports.getUniqueGroupIds = getUniqueGroupIds;
function isDisabled(rows) {
    var shouldBeDisabled = true;
    for (var i = 0; i < rows.length; i++) {
        var group = rows[i].group;
        var emails = rows[i].emails;
        if (group !== -2 && emails.length > 0) {
            shouldBeDisabled = false;
        }
        else {
            shouldBeDisabled = true;
            break;
        }
    }
    return shouldBeDisabled;
}
function getNewRow(addNewRow, items) {
    addNewRow({
        uuid: (0, uuid_1.v4)(),
        group: -2,
        emails: '',
        language: ''
    });
}
exports.timeout = {};
var setVal = function (item, props) {
    if (exports.timeout && exports.timeout[item.uuid]) {
        return props.tempValue === null ? item.emails : props.tempValue;
    }
    else {
        return item.emails;
    }
};
exports.setVal = setVal;
